export default __webpack_public_path__ + "static/media/badgesImage.1b6bb4de.svg";